// jsonp.js
function jsonp(url) {
    return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        const uniqueCallbackName =
            "jsonpCallback_" + Math.random().toString(36).substr(2, 9);

        const cleanup = () => {
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }
            delete window[uniqueCallbackName];
        };

        window[uniqueCallbackName] = data => {
            cleanup();
            resolve(data);
        };

        const separator = url.indexOf("?") >= 0 ? "&" : "?";
        script.src = `${url}${separator}callback=${uniqueCallbackName}`;
        script.async = true;
        script.onerror = () => {
            cleanup();
            reject(new Error(`JSONP request to ${url} failed`));
        };

        document.body.appendChild(script);
    });
}

// 使用封装的jsonp方法请求数据
// import jsonp from '../utils/jsonp';  // 根据实际路径导入jsonp函数
// jsonp('https://some-domain.com/api/data', 'callback')
//     .then(response => {
//         this.data = response;
//     })
//     .catch(error => {
//         console.error('JSONP request failed:', error);
//     });

export default jsonp;
